import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/shared/ui/primitives'

type SubscriptionRequiredDialogProps = {
  open: boolean
  featureLabel: string | null
  onClose: () => void
  onResubscribe: () => void
}

export function SubscriptionRequiredDialog({
  open,
  featureLabel,
  onClose,
  onResubscribe,
}: SubscriptionRequiredDialogProps) {
  return (
    <Dialog open={open} onOpenChange={(nextOpen) => !nextOpen && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>No active subscription</DialogTitle>
          <DialogDescription>
            {`Your organization’s subscription is inactive. Resubscribe to access ${featureLabel ?? 'this feature'}.`}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button type="button" variant="outline" onClick={onClose}>
            Not now
          </Button>
          <Button type="button" onClick={onResubscribe}>
            Resubscribe
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
